/**
 * Gestione input radio button
 */

export default $ => {

  const checkedClassName = 'radio-button-checked';

  const updateAllRadios = radioButtonsCollection => {
    radioButtonsCollection.each(function() {
      updateRadio($(this));
    });
  };

  const findRadio = (radioButtons) => {
    return $('input[type="radio"]', radioButtons);
  };

  const updateRadio = radioButton => {
    if (findRadio(radioButton).is(':checked')) {
      radioButton.addClass(checkedClassName);
    } else {
      radioButton.removeClass(checkedClassName);
    }
  };

  $('[data-radio-button]').each(function() {
    const self = $(this);
    const itemSelector = self.data('radio-button');
    const buttons = self.find(itemSelector);

    // Move the images and indicator inside the label
    buttons.each(function() {
      const button = $(this);
      button.find('label').prepend(button.find('.eRadioButton__Image'));
      button.find('label').prepend(button.find('.eRadioButton__Indicator'));
    });

    // Update all at page-load
    updateAllRadios(buttons);

    // On change update all
    findRadio(buttons).on('change', () => {
      updateAllRadios(buttons);
    });
  });
};



// WEBPACK FOOTER //
// ./assets/js/component/radio-button.js